import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=05538360&scoped=true"
import script from "./Window.vue?vue&type=script&lang=js"
export * from "./Window.vue?vue&type=script&lang=js"
import style0 from "./Window.vue?vue&type=style&index=0&id=05538360&prod&lang=scss&scoped=true"
import style1 from "./Window.vue?vue&type=style&index=1&id=05538360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05538360",
  null
  
)

export default component.exports